require('../../modules/es7.array.flat-map');
module.exports = require('../../modules/_core').Array.flatMap;



//////////////////
// WEBPACK FOOTER
// ./~/@babel/polyfill/~/core-js/fn/array/flat-map.js
// module id = nfF3
// module chunks = 0